"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.thumbnailStore = exports.hashShape = exports.convertMixedShapeArrayToFeatureCollection = exports.getStylesById = exports.convertStyledShapeArrayToStyledFeatureArray = exports.convertShapeWithStyleToFeatureWithStyle = exports.convertShapeArrayToFeatureArray = exports.ensureShapeIsMultiPolygonFeatureWithId = exports.convertPolygonFeatureToMultipolygonFeature = exports.shouldUseStyledShapes = exports.isArrayOfObjectsWithShapes = exports.hasShapeInObject = exports.featureIsMultiPolygon = exports.featureIsPolygon = exports.shapeIsFeatureCollection = exports.shapeIsFeature = exports.shapeIsMultiPolygon = exports.shapeIsPolygon = exports.defaultStyles = void 0;
var turf_1 = require("@turf/turf");
var localforage_1 = __importDefault(require("localforage"));
var lodash_1 = require("lodash");
var object_hash_1 = __importDefault(require("object-hash"));
exports.defaultStyles = {
    strokeWidth: 0,
    strokeFill: "#ccc",
    fill: "#ccc",
};
/**
 * Type Guards
 */
var shapeIsPolygon = function (shape) {
    return !!shape && "type" in shape && shape.type === "Polygon";
};
exports.shapeIsPolygon = shapeIsPolygon;
var shapeIsMultiPolygon = function (shape) {
    return !!shape && "type" in shape && shape.type === "MultiPolygon";
};
exports.shapeIsMultiPolygon = shapeIsMultiPolygon;
var shapeIsFeature = function (shape) {
    return !!shape && "type" in shape && shape.type === "Feature";
};
exports.shapeIsFeature = shapeIsFeature;
var shapeIsFeatureCollection = function (shape) {
    return !!shape && "type" in shape && shape.type === "FeatureCollection";
};
exports.shapeIsFeatureCollection = shapeIsFeatureCollection;
var featureIsPolygon = function (shape) { return shape.geometry.type === "Polygon"; };
exports.featureIsPolygon = featureIsPolygon;
var featureIsMultiPolygon = function (shape) { return shape.geometry.type === "MultiPolygon"; };
exports.featureIsMultiPolygon = featureIsMultiPolygon;
var hasShapeInObject = function (shape) { return !!shape && "shape" in shape && !("id" in shape); };
exports.hasShapeInObject = hasShapeInObject;
var isArrayOfObjectsWithShapes = function (shape) {
    return !!shape && Array.isArray(shape) && (0, exports.hasShapeInObject)(shape[0]);
};
exports.isArrayOfObjectsWithShapes = isArrayOfObjectsWithShapes;
/**
 * The actually render function of the worker uses this to determine if it will be creating
 * a customized style set for the appearance of the polygons.
 */
var shouldUseStyledShapes = function (shape) {
    return (0, exports.hasShapeInObject)(shape) || (0, exports.isArrayOfObjectsWithShapes)(shape);
};
exports.shouldUseStyledShapes = shouldUseStyledShapes;
/**
 * Despite the fact that turf handles combining Polygon and MultiPolygon features just fine,
 * its typings insist that not to be true. Because of that, we convert all Polygons
 * to MultiPolygons before combining them.
 */
var convertPolygonFeatureToMultipolygonFeature = function (feature, styleId) { return (__assign(__assign({}, feature), { geometry: __assign(__assign({}, feature.geometry), { type: "MultiPolygon", coordinates: [feature.geometry.coordinates] }), properties: __assign(__assign({}, feature.properties), { styleId: styleId }) })); };
exports.convertPolygonFeatureToMultipolygonFeature = convertPolygonFeatureToMultipolygonFeature;
/**
 * No matter what type is passed in, return a Feature<MultiPolygon> because
 * then we can correctly create a feature collection.
 */
var ensureShapeIsMultiPolygonFeatureWithId = function (shape, styleId) {
    /**
     * This function has a weird assertion at the end, because TS gets
     * confused and doesn't correctly restrict types. There are four
     * things that `shape` might be:
     *
     * - Polygon
     * - MultiPolygon
     * - Feature<Polygon>
     * - Feature<MultiPolygon>
     *
     * This function is annotated with the spot that catches each case.
     */
    if ((0, exports.shapeIsPolygon)(shape)) {
        // Polygon ✅
        return (0, turf_1.multiPolygon)([shape.coordinates], { styleId: styleId });
    }
    else if ((0, exports.shapeIsMultiPolygon)(shape)) {
        // MultiPolygon ✅
        return (0, turf_1.multiPolygon)(shape.coordinates, { styleId: styleId });
    }
    else {
        if ((0, exports.featureIsPolygon)(shape)) {
            // Feature<Polygon> ✅
            return (0, exports.convertPolygonFeatureToMultipolygonFeature)(shape, styleId);
        }
        return __assign(__assign({}, shape), { properties: __assign(__assign({}, shape.properties), { styleId: styleId }) });
    }
};
exports.ensureShapeIsMultiPolygonFeatureWithId = ensureShapeIsMultiPolygonFeatureWithId;
/**
 * A shape array is an array of AcceptedGeoJSON that isn't a FeatureCollection.
 * We make sure they're all Feature<MultiPolygon> so that we can combine them into a
 * FeatureCollection later.
 */
var convertShapeArrayToFeatureArray = function (shapeArray, id) {
    return shapeArray.map(function (shape) { return (0, exports.ensureShapeIsMultiPolygonFeatureWithId)(shape, id); });
};
exports.convertShapeArrayToFeatureArray = convertShapeArrayToFeatureArray;
/**
 * Convert the user's passed object into one we'll use to create styles
 */
var convertShapeWithStyleToFeatureWithStyle = function (shapeWithStyle, styleId) { return ({
    styleId: styleId,
    style: shapeWithStyle.style,
    shape: (0, exports.ensureShapeIsMultiPolygonFeatureWithId)(shapeWithStyle.shape, styleId),
}); };
exports.convertShapeWithStyleToFeatureWithStyle = convertShapeWithStyleToFeatureWithStyle;
/**
 * If the user wants to style their polygons, they can pass in a very generously typed
 * array, which we ensure becomes an array of Feature objects
 */
var convertStyledShapeArrayToStyledFeatureArray = function (shapeArray, styleId) {
    return shapeArray.map(function (shape, index) {
        return (0, exports.convertShapeWithStyleToFeatureWithStyle)(shape, styleId + "-" + index);
    });
};
exports.convertStyledShapeArrayToStyledFeatureArray = convertStyledShapeArrayToStyledFeatureArray;
/**
 * Take an array of styled objects and convert them into the format that `render` will use.
 *
 * Each shape has a styleId property that svg2json will look up in this object when rendering.
 */
var getStylesById = function (shapeArray) {
    var allStyles = shapeArray.map(function (_a) {
        var style = _a.style, styleId = _a.styleId;
        return (__assign(__assign(__assign({}, exports.defaultStyles), style), { styleId: styleId }));
    });
    return (0, lodash_1.keyBy)(allStyles, "styleId");
};
exports.getStylesById = getStylesById;
/**
 * Combine an array almost anything into a feature collection that renders
 * as stacked polygons, last item on top.
 */
var convertMixedShapeArrayToFeatureCollection = function (shapeArray, styleId) {
    var nonFeatureCollectionItems = shapeArray.filter(function (feature) {
        return !(0, exports.shapeIsFeatureCollection)(feature);
    });
    var convertedToFeatures = (0, exports.convertShapeArrayToFeatureArray)(nonFeatureCollectionItems, styleId);
    var featureCollectionFeatures = shapeArray
        .filter(function (feature) {
        return (0, exports.shapeIsFeatureCollection)(feature);
    })
        .map(function (featureCollection) { return featureCollection.features; })[0];
    var allFeatures = __spreadArray(__spreadArray([], (convertedToFeatures || []), true), (featureCollectionFeatures || []), true);
    return (0, turf_1.featureCollection)(allFeatures);
};
exports.convertMixedShapeArrayToFeatureCollection = convertMixedShapeArrayToFeatureCollection;
/**
 * Take the shape input and hash it
 */
var hashShape = function (shape) {
    return (0, object_hash_1.default)((0, lodash_1.isPlainObject)(shape) ? shape : { shape: shape });
};
exports.hashShape = hashShape;
exports.thumbnailStore = localforage_1.default.createInstance({
    name: "GeoThumbnailWorkerCache",
});
